import { render, staticRenderFns } from "./EmpresaGestaoContratos.vue?vue&type=template&id=52bf71d2&lang=pug"
import script from "./EmpresaGestaoContratos.vue?vue&type=script&lang=js"
export * from "./EmpresaGestaoContratos.vue?vue&type=script&lang=js"
import style0 from "./EmpresaGestaoContratos.vue?vue&type=style&index=0&id=52bf71d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports